import React from 'react';
import SearchField from '../../../UI/SearchField/SearchField';
import styles from './Collections.module.scss';
import CheckboxSquare from '../../../UI/CheckboxSquare/CheckboxSquare';

function Collections() {
  return (
    <div className={styles.collections}>
      <div className={styles.collectionsSearch}>
        <SearchField placeholder="Search collection"/>
      </div>
      <div className={styles.collectionsList}>
        <div className={styles.collection}>
          <div
            className={styles.collectionImg}
            style={{backgroundImage: `url(https://t1m-nft.bit.team/product/yatechnar/6164dbc680e50/55b75ae9-4465-45a2-b27a-fa377a6e745e_thumb.webp)`}}
          />
          <div className={styles.collectionText}>
            <div className={styles.collectionTitle}>Broxie NFT</div>
            <div>1221</div>
          </div>
          <div className={styles.collectionCheckbox}>
            <CheckboxSquare isChecked/>
          </div>
        </div>
        <div className={styles.collection}>
          <div
            className={styles.collectionImg}
            style={{backgroundImage: `url(https://t1m-nft.bit.team/product/yatechnar/6164dbc680e50/55b75ae9-4465-45a2-b27a-fa377a6e745e_thumb.webp)`}}
          />
          <div className={styles.collectionText}>
            <div className={styles.collectionTitle}>Broxie NFT</div>
            <div>1221</div>
          </div>
          <div className={styles.collectionCheckbox}>
            <CheckboxSquare/>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Collections;
